import { type FC } from "react";

import { useUserContacts } from "@/shared/hooks/useUserContacts";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

export const AdminSignoffIntroScreen: FC<FlowCustomComponentProps> = ({ answers }) => {
  const { contacts } = useUserContacts();

  const mode = (answers["admin_confirm_admin_mode"] as string) ?? "sole";
  const isSomeoneElse = mode === "someone_else";

  const adminName = (() => {
    if (!isSomeoneElse) return "you";
    const fullName = (answers["admin_someone_else_full_name"] as string) ?? "";
    if (fullName) return fullName.split(" ")[0];
    const topPersonId = answers["admin_confirm_admin_top_person_id"] as string;
    if (topPersonId) {
      const contact = contacts.find((c) => String(c.id) === topPersonId);
      if (contact?.first_name) return contact.first_name;
    }
    return "the administrator";
  })();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          Last step, let's confirm family sign-offs
        </p>
        <p className="text-secondary tracking-[-0.28px]">
          {isSomeoneElse
            ? `Everyone with the same right to serve as ${adminName} needs to agree, or the court notifies them formally. You can fill this in now, and ${adminName} reviews it before filing.`
            : "Everyone with the same right to serve as you needs to agree, or the court notifies them formally. Tell us where each person stands, so the right court forms are listed."}
        </p>
      </div>
    </div>
  );
};
